import { Link } from 'react-router-dom';
import { API_BASE_URL, openInGoogleMaps } from '../../utils';
import './PackageCardNew.css'
import { IoRestaurant } from "react-icons/io5";
import { PiShareFatLight } from "react-icons/pi";
import { MdOutlineFilterAlt } from "react-icons/md";
import { MdOutlinePushPin } from "react-icons/md";
import buffe from '../image/buffe.png'
import { FaDirections } from "react-icons/fa";

import { BiDrink } from "react-icons/bi";
import TextRoller from './TextRoller';
import PlatformChargesTooltip from './PlatformChargesTooltip';
import ShareModal from '../../Feed Page/custom-comp/ShareModal';
import { useState } from 'react';
import { HiOutlineLocationMarker } from "react-icons/hi";
import { CiHeart } from "react-icons/ci";
import PackageTitleName from './PackageTitleName';
import ServiceTimeOfClub from './ServiceTimeOfClub';

const url = `${API_BASE_URL}/master/assets/uploads/`
export default function PackageCardNew({ data, isFiltered, isDetailPage }) {


    const [isShareModalOpen, setIsShareModalOpen] = useState(false);
    const [shareTitle, setShareTitle] = useState('');
    const [currentShareUrl, setCurrentShareUrl] = useState('');



    const format = (str) => (str ? str.trim().replace(/\s+/g, "-").toLowerCase() : "");
    function generateClubUrl(clubName, cityName, areaName, title) {
        const format = (str) => (str ? str.trim().replace(/\s+/g, "-").toLowerCase() : "");

        return `/party-package/${format(clubName)}-${format(cityName)}-${format(areaName)}/${format(title)}`;
    }

    function generateClubDetailUrl(clubName, cityName, areaName, title) {
        const format = (str) => (str ? str.trim().replace(/\s+/g, "-").toLowerCase() : "");

        return `/${format(clubName)}-${format(cityName)}-${format(areaName)}`;
    }



    const packageMessages = [
        `flat 50% off up to 750 on booking Amount | coupon code PARTY25`,
        `Use up to 500 carrots on this booking - T&C applied`,
    ];

    const packageUrl = (clubName, cityName, areaName, title) => {
        return `${API_BASE_URL}/party-package/${format(clubName)}-${format(cityName)}-${format(areaName)}/${format(title)}`;
    };


    const handleShare = (e, eventData) => {
        e.preventDefault();
        e.stopPropagation();

        let url = packageUrl(eventData.clubName, eventData.cityName, eventData.areaName, eventData.title);

        setCurrentShareUrl(url);
        setShareTitle(`Check out ${eventData.clubName}${eventData.title ? " - " + eventData.title : ""}`);
        setIsShareModalOpen(true);
    };


    console.log("data in package card new", data)


    return (
        <>

            <div className='package-new-card'>

                <div className='event-new-card-image-section position-relative' style={{
                    backgroundImage: `url(${(data?.packageThumbnail && url + data.packageThumbnail) ||
                        (data?.thumbnail && url + data.thumbnail || "https://images.unsplash.com/photo-1468465236047-6aac20937e92?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MzV8fGRyaW5rfGVufDB8fDB8fHww")})`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat'
                }} >
                    <div className='event-detail-page-design-content1-img-blur-overlay'>

                        <div className='icon-seton-image'>
                            <div className='d-flex gap-2'>
                                <div className='pnats-icon-wrapper-icon-desktop icon cursor-pointer' onClick={(e) => handleShare(e, data)}>
                                    <CiHeart size={22} />
                                </div>
                                <div className='pnats-icon-wrapper-icon-mobile icon cursor-pointer ' onClick={(e) => handleShare(e, data)}>
                                    <PiShareFatLight size={22} />
                                </div>
                            </div>
                        </div>
                        <img
                            src={
                                data?.packageThumbnail
                                    ? url + data.packageThumbnail
                                    : data?.thumbnail
                                        ? url + data.thumbnail
                                        : "https://images.unsplash.com/photo-1468465236047-6aac20937e92?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MzV8fGRyaW5rfGVufDB8fDB8fHww"
                            }
                            alt={data?.title || "Package Image"}
                            onError={(e) => {
                                e.currentTarget.onerror = null; // prevent infinite loop
                                e.currentTarget.src =
                                    "https://images.unsplash.com/photo-1468465236047-6aac20937e92?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MzV8fGRyaW5rfGVufDB8fDB8fHww";
                            }}
                        />

                    </div>

                </div>


                <div className='package-new-card-image-section-wrapper'>
                    <div className='package-new-card-content-section'>
                        <div className='package-new-card-text-section-wrapper'>
                            <div className='package-new-card-text-section'>
                                {isDetailPage ? (
                                    <><h1>{data?.title}</h1></>
                                ) : (

                                    <h1>
                                        <span className='package-new-card-img-icon-section-logo'>
                                            <img
                                                src={data?.clubLogo ? url + data.clubLogo : url + data?.profile_pic}
                                                alt=""
                                                onError={(e) => {
                                                    e.currentTarget.onerror = null; // prevent infinite loop
                                                    e.currentTarget.src = "https://images.unsplash.com/photo-1468465236047-6aac20937e92?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MzV8fGRyaW5rfGVufDB8fDB8fHww"
                                                }}
                                            />

                                        </span>
                                        {data?.clubName || data?.name}
                                    </h1>
                                )}

                                {!isDetailPage && (
                                    <>
                                        {data?.address && (
                                            <div className='package-new-card-text-section-location'>
                                                <p><span className='icon-size-set'><HiOutlineLocationMarker /></span> {data?.address?.length > 24 ? data?.address?.slice(0, 24) + "..." : data?.address}</p>
                                                {data?.distance && (
                                                    <div className='package-new-card-text-section-location-distance' onClick={() => openInGoogleMaps(data?.address)}>
                                                        <span><FaDirections /> {Math.round(data?.distance)} Kms</span>
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </>
                                )}

                                {isDetailPage ? (
                                    <p>
                                        <span className='package-new-card-img-icon-section-logo'>
                                            <img
                                                src={data?.clubLogo ? url + data.clubLogo : url + data?.profile_pic}
                                                alt=""
                                                onError={(e) => {
                                                    e.currentTarget.onerror = null; // prevent infinite loop
                                                    e.currentTarget.src = "https://images.unsplash.com/photo-1468465236047-6aac20937e92?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MzV8fGRyaW5rfGVufDB8fDB8fHww"
                                                }}
                                            />
                                        </span>
                                        {data?.clubName || data?.name}
                                    </p>
                                ) : (

                                    <PackageTitleName title={data?.title} />
                                )}

                                <>
                                    {/* <div className='d-flex flex-column gap-2 align-items-start'>
                                        <span className='bid-new-card-text-section-time-service'>Service Time</span>
                                        <div className='bid-new-card-text-section-food-time'>

                                            {data?.foodserving !== "" && (
                                                <p> <IoRestaurant /> {data?.foodserving || "--"}</p>
                                            )}
                                            {data?.alcoholserving !== "" && (
                                                <p> <BiDrink /> {data?.alcoholserving || "--"}</p>
                                            )}
                                        </div>
                                    </div> */}
                                    <ServiceTimeOfClub foodserving={data?.foodserving} alcoholserving={data?.alcoholserving} />
                                </>

                            </div>

                        </div>

                        <div className='package-new-card-about-text-section'>
                            <div className='pnats-icon-wrapper'>

                                {/* <div className='pnats-icon-wrapper-icon-desktop' onClick={(e) => handleShare(e, data)}>
                                    <PiShareFatLight size={25} />
                                </div> */}
                                {isFiltered && (
                                    <div className='pnats-icon-wrapper-icon pnats-icon-wrapper-icon2'>
                                        <MdOutlineFilterAlt size={25} />
                                        <div className='pnats-icon-wrapper-icon pnats-icon-wrapper-icon3'>
                                            <MdOutlinePushPin size={10} />
                                        </div>
                                    </div>
                                )}
                            </div>




                            <div className='PackageNewCard-about-text-section'>
                                <h1>Inclusion</h1>
                                <div>
                                    <ul className='PackageNewCard-about-text-section-list'>
                                        <li>3 Starters</li>
                                        <li>2 Main Course</li>
                                        <li>13+ Alcohol Drinks</li>
                                        <li>5+ Non-Alcohol Drinks</li>
                                    </ul>
                                </div>
                                <p>8+ More</p>


                            </div>

                        </div>
                    </div>

                    <div className='w-100 d-flex flex-column justify-content-center gap-2'>
                        <Link to={generateClubUrl(data?.clubName, data?.cityName, data?.areaName, data?.title)} style={{ textDecoration: "none", width: "100%" }}>
                            <div className='package-new-card-text-section-button'>
                                <button className='m-hide'>View Details</button>
                                <div className='package-new-card-break-line'></div>
                                <div className='package-new-card-text-section-text-wrapper'>
                                    <TextRoller messages={packageMessages} />
                                </div>
                            </div>
                        </Link>
                        <Link className='w-100 d-flex flex-column justify-content-center' to={generateClubUrl(data?.clubName, data?.cityName, data?.areaName, data?.title)} style={{ textDecoration: "none", width: "100%" }}>
                            <button className='btn text-btn d-hide'>View Details</button>
                        </Link>
                    </div>



                </div>

            </div>

            <ShareModal
                isOpen={isShareModalOpen}
                onClose={() => setIsShareModalOpen(false)}
                shareUrl={currentShareUrl}
                title={shareTitle}
            />
        </>
    )
}
